import * as yup from 'yup';
import { FORM, MAX_LENGTH } from './constants';

const required = (label: string) => `${label}を入力してください。`;
const tooLong = (label: string, max: number) =>
  `${label}は${max}文字以内で入力してください。`;

/** 新規作成は課題の選択だけ。中身は作成後に「課題を知る」「そなえる」タブで埋める */
// 新規作成と編集で項目が全く違うため、戻り値の型は union にせず ObjectSchema に寄せる
export const formSchemaFn = (formName: FORM): yup.ObjectSchema<any> => {
  if (formName === FORM.CREATE_AYUMI) {
    return yup.object().shape({
      topicKey: yup.string().required('課題を選択してください。'),
    });
  }

  return yup.object().shape({
    summary: yup
      .string()
      .trim()
      .nullable()
      .max(MAX_LENGTH.SUMMARY, tooLong('説明文', MAX_LENGTH.SUMMARY)),
    knowTitle: yup
      .string()
      .trim()
      .nullable()
      .max(MAX_LENGTH.KNOW_TITLE, tooLong('タイトル', MAX_LENGTH.KNOW_TITLE)),
    videoUrl: yup
      .string()
      .trim()
      .nullable()
      .max(MAX_LENGTH.VIDEO_URL, tooLong('動画URL', MAX_LENGTH.VIDEO_URL)),
    knowBody: yup.string().trim().nullable(),
    questions: yup.array().of(
      yup.object().shape({
        question: yup.string().trim().required(required('質問文')),
        answerLabelSet: yup
          .number()
          .required('回答ボタンラベルを選択してください。'),
        explanation: yup.string().trim().nullable(),
      }),
    ),
  });
};

/** そなえるタブのカテゴリカードは1枚ずつ保存するので、専用スキーマを分ける */
export const categorySchemaFn = () =>
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(required('カテゴリ名'))
      .max(
        MAX_LENGTH.CATEGORY_NAME,
        tooLong('カテゴリ名', MAX_LENGTH.CATEGORY_NAME),
      ),
    priority: yup.number().required('優先度を選択してください。'),
    impact: yup.number().required('影響度を選択してください。'),
    frequency: yup.number().required('頻度を選択してください。'),
    score: yup
      .number()
      .typeError('獲得点数は数値で入力してください。')
      .min(0, '獲得点数は0以上で入力してください。')
      .required(required('獲得点数')),
    items: yup.array().of(
      yup.object().shape({
        serviceType: yup.number().required('区分を選択してください。'),
        title: yup
          .string()
          .trim()
          .required(required('タイトル'))
          .max(
            MAX_LENGTH.ITEM_TITLE,
            tooLong('タイトル', MAX_LENGTH.ITEM_TITLE),
          ),
        description: yup.string().trim().nullable(),
      }),
    ),
  });
